import { ReactNode } from 'react';
import '../../../dashboard-reset.css';

interface ComponentActionItemProps {
  children: ReactNode;
}

export default function ComponentActionItem({ children }: ComponentActionItemProps) {
  return (
    <div className="mx-auto mb-5 flex flex-col items-center rounded-lg bg-[var(--color-background-input)] p-5 last:mb-0 md:max-w-[750px] md:items-start md:px-12 md:py-9 md:pb-[38px]">
      {/* Header */}
      <div className="flex flex-col gap-1 md:items-center">{children}</div>
    </div>
  );
}
